<template>
  <!--首页头部-->
  <div id="tophead">
    <div class="main">
      <div class="logo" @click="gotoIndex"></div>
      <div class="zx">
        <router-link :to="{name: 'AppDown'}">
          <img src="../../../assets/icon/common_icon_down.png" alt="">
          APP下载
        </router-link>
        <router-link :to="{name: 'PersonInfo'}" v-if="this.$store.state.uid" class="portrait" :style="{backgroundImage: 'url(' + this.$store.state.portrait + ')'}">
        </router-link>
        <a @click="login" v-else>
          <img src="../../../assets/icon/common_icon_login.png" alt="">
          登录
        </a>
      </div>
    </div>
    <div class="border-bottom"></div>
  </div>
</template>

<script>
export default {
  name: 'topHead',
  props: [
    'pageName'
  ],
  methods: {
    gotoIndex () {
      this.$router.push({name: 'Index'})
    },
    login () {
      if (this.pageName === 'ClassDetailTeacher') {
        this.$emit('listenLogin', true)
        return false
      }
      this.$router.push({name: 'PwdLogin', query: {backto: this.pageName ? this.pageName : 'Index'}})
    }
  }
}
</script>

<style scoped lang="stylus">
  #tophead
    .main
      display: flex
      justify-content: space-between
      align-items: center
      width: 100%
      height: .92rem
      overflow: visible
      background-color: transparent
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      .logo
        width: 3.54rem
        height: .47rem
        background: url(../../../assets/icon/common_icon_logo.png) no-repeat center
        -webkit-background-size: 100%
        background-size: 100%
      .zx
        display: flex
        justify-content: space-between
        align-items: center
        width: 2rem
        height: .7rem
        a
          display: block
          width: .95rem
          font-size: .222rem
          color: #333
          text-align: center
          &.portrait
            width: .64rem
            height: .64rem
            border: .01rem solid #ccc
            background: url(../../../assets/icon/pwdforget_icon_logo.png) no-repeat center
            -webkit-background-size: 100%
            background-size: 100%
            overflow: hidden
            -webkit-border-radius: 50%
            -moz-border-radius: 50%
            border-radius: 50%
            img
              width: 100%
              height: 100%
          img
            display: block
            width: .43rem
            height: .43rem
            margin: 0 auto
          &:first-child
            img
              position: relative
              left: .05rem
    .border-bottom
      position: relative
      z-index: 10000
      height: .17rem
      background: url(../../../assets/img/common_img_topbodershadow.png) no-repeat center bottom
      -webkit-background-size: 100%
      background-size: 100%
</style>



// WEBPACK FOOTER //
// src/components/share/header/topHead.vue